import React from 'react';
/* eslint-disable */

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
// import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { useEffect } from 'react';
import Grid from '@mui/system/Unstable_Grid/Grid';
import { TextField } from '@mui/material';
import { useState } from 'react';
import Box from '@mui/material/Box';
import { handleCatchError } from 'utils/CatchHandler';
import { handleCapture } from 'views/utilities/BiometricCapture';
import ViewCustomerAuth from './BioAuthAnimation';
import Spinner from 'views/Components/LoadingSinner';
import { globalNotifySuccess } from 'views/utilities/AlertToast';
import { useNavigate } from 'react-router';
import { dmtFundTransferApi, generateOtpApi } from 'utils/API/Merchant APIs/DmtApiCalls';
import Link from '@mui/material/Link';
import { useDispatch } from 'react-redux';
import { fetchWalletBalanceAsync } from 'redux/WalletSlice';
import MultipleOtpComponent from '../../MultipleOtpComponent';
const commonStyles = {
    m: 0
};
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
function TransferPageBioAuth({ showModal, benAcc, id, beneName, beneId, paymentMode, amount, data, closeModalView, serviceCharge }) {
    const [open, setOpen] = React.useState(false);
    const [OtpPin, setOtpPin] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [showFingerGif, setShowFingerGif] = useState(false);
    const [OtpRefrenceId, setOtpRefrenceId] = useState('');
    const [receiptDetails, setReceiptDetails] = useState({
        orderId: '',
        isTransfer: true,
        status: '',
        reqtype: '',
        refnumber: '',
        date: ''
    });
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const dmt_type = 1;
    // useEffect(() => {
    //     setOpen(true);
    //     if (showModal) {
    //         handleGenerateOtp();
    //     }
    // }, [showModal]);
    const handleClose = () => {
        closeModalView(false);
        setOpen(false);
    };
    // const handleOtpChange = (e) => {
    //     let amountValue = e.target.value.replace(/[^\d.]/g, '');
    //     amountValue = amountValue.slice(0, 4);
    //     setOtpPin(amountValue);
    // };
    const handleGenerateOtp = async (otpAmount, is_split) => {
        try {
            setOtpPin('');
            setIsLoading(true);
            const agentid = localStorage.getItem('id');
            const customerId = id;
            const BeneName = beneName;
            const BeneAccountNo = benAcc;
            const payload = {
                agentid,
                BeneName,
                beneId,
                customerId,
                BeneAccountNo,
                amount: otpAmount,
                dmt_type,
                paymentMode,
                is_split
            };
            const response = await generateOtpApi(payload);
            if (response?.data?.success) {
                setOtpRefrenceId(response?.data?.OTPReferenceID);
            }
            setIsLoading(false);
            return response?.data?.success;
        } catch (error) {
            setIsLoading(false);
            console.log(error.message);
            handleCatchError(error);
        }
    };
    const handleFundTransfer = async ({ otp, amount, split_status, splitId }) => {
        try {
            setIsLoading(true);
            const agentid = localStorage.getItem('id');
            const customerId = id;
            const Pid = 0;
            const payload = {
                agentid,
                customerId,
                beneId,
                amount,
                paymentMode,
                OtpRefrenceId,
                Pid,
                dmt_type,
                OtpPin: otp,
                Pid,
                dmt_type,
                split_status,
                split_id: splitId
            };
            const response = await dmtFundTransferApi(payload);
            const orderId = response?.data?.data?.orderId;
            const status = response?.data?.data?.status;
            const reqtype = response?.data?.data?.reqtype;
            const refnumber = response?.data?.data?.refnumber;
            const date = response?.data?.data?.date;
            const uniqueSid = response?.data?.data?.unique_sid;
            setReceiptDetails({ orderId, isTransfer: true, status, reqtype, refnumber, date });
            if (orderId) {
                const isTransfer = true;
                // navigate('/dmt/dmtreciept', { state: { data, orderId, isTransfer, status, reqtype, refnumber, date } });
            }
            setIsLoading(false);
            dispatch(fetchWalletBalanceAsync());
            return { isSuccess: response?.data?.success, orderId, status, reqtype, refnumber, date, uniqueSid };
        } catch (error) {
            setIsLoading(false);
            console.log(error.message);
            handleCatchError(error);
        }
    };
    // const onCaptureSuccess = (data) => {
    //     setShowFingerGif(false);
    //     if (!data === false) {
    //         handleFundTransfer(data);
    //     }
    // };
    // const handleFingerAnimation = () => {
    //     setShowFingerGif(true);
    //     const timeoutId = setTimeout(() => {
    //         handleCapture(onCaptureSuccess);
    //     }, 1000);
    //     return () => clearTimeout(timeoutId);
    // };

    //New flow for muliple otp>>>>>
    useEffect(() => {
        setOpen(true);
    }, []);
    return (
        <>
            {/* <Dialog
                open={open}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                aria-describedby="alert-dialog-slide-description"
                sx={{
                    '& .MuiDialog-paper': {
                        width: '100%',
                        maxWidth: '600px',
                        margin: '0 auto',
                        padding: { xs: '10px', sm: '20px' },
                        '@media (max-width: 600px)': {
                            width: '90%'
                        }
                    }
                }}
            >
                <Box
                    sx={{
                        width: '100%',
                        height: 'auto',
                        backgroundColor: '#fff',
                        ...commonStyles,
                        borderRadius: 2,
                        marginBottom: 2,
                        padding: { xs: '10px', sm: '20px' }
                    }}
                >
                    <>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12}>
                                <TextField
                                    id="outlined-basic"
                                    label="OTP Number"
                                    variant="outlined"
                                    fullWidth
                                    required
                                    value={OtpPin}
                                    onChange={handleOtpChange}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} container justifyContent="flex-end">
                                <Link component="button" variant="body2" onClick={handleGenerateOtp}>
                                    Resend OTP
                                </Link>
                            </Grid>
                        </Grid>
                        <DialogActions>
                            <Button variant="contained" fullWidth disabled={isLoading || !OtpPin} onClick={handleFundTransfer}>
                                Verify
                            </Button>
                        </DialogActions>
                    </>
                </Box>
            </Dialog> */}

            <Spinner loading={isLoading} />
            {showFingerGif && <ViewCustomerAuth />}
            <MultipleOtpComponent
                open={open}
                onClose={handleClose}
                totalAmount={amount}
                sendOtp={handleGenerateOtp}
                transferSubmit={handleFundTransfer}
                dmt_type={dmt_type}
                otpLength={4}
                serviceCharge={serviceCharge}
                recieptData={{
                    ...receiptDetails,
                    data
                }}
            />
        </>
    );
}

export default TransferPageBioAuth;
